import RadioButton from "./RadioButton";
import CheckBox from "./CheckBox";
import DropdownFilter from "./DropdownFilter";
import { useEffect, useState } from "react";
import { pre } from "framer-motion/client";

export function DashboardStorePanelFilterSectionExportableFieldsTypology({
  typeId,
  onChange,
}) {
  const [selectedFields, setSelectedFields] = useState([]);
  const [toggleGroupedFields, setToggleGroupedFields] = useState(false);
  const [groupedPair, setGroupedPair] = useState({
    first: "",
    second: "",
  });

  let options = ["Genero", "Forma", "Materia"];

  function getFields(id) {
    const fieldsByFamily = {
      0: ["Tipo"],
      1: ["Material", "Tipo"],
      2: ["Tipo", "Uso"],
      3: ["Capacidad"],
      4: ["Genero", "Forma", "Material"],
      5: ["Categoria"],
      6: ["Genero", "Forma", "Material"],
    };
    return fieldsByFamily[id] ?? [];
  }

  function initializeDefaultFields(id) {
    const fieldsByFamily = {
      0: ["Tipo"],
      1: ["Material"],
      2: ["Tipo"],
      3: ["Capacidad"],
      4: ["Genero"],
      5: ["Categoria"],
      6: ["Genero"],
    };
    return fieldsByFamily[id] ?? [];
  }

  useEffect(() => {
    if (typeId !== -1) setSelectedFields(initializeDefaultFields(typeId));
    setToggleGroupedFields(false);
  }, [typeId]);

  useEffect(() => {
    if (toggleGroupedFields) {
      setSelectedFields([]);
      setGroupedPair({
        first: "Genero",
        second: "Forma",
      });
    } else {
      setGroupedPair({
        first: "",
        second: "",
      });
    }
  }, [toggleGroupedFields]);

  useEffect(() => {
    const defaultFields = initializeDefaultFields(typeId);

    const newFields =
      groupedPair.first || groupedPair.second
        ? [groupedPair.first, groupedPair.second].filter(Boolean)
        : defaultFields;

    setSelectedFields(newFields);
  }, [groupedPair, typeId]);

  useEffect(() => {
    onChange(selectedFields);
  }, [selectedFields]);

  return (
    <div className="dashboard-section">
      <div className="opt-table-title opt-table-title-dash-stats">
        Campos exportables por tipo de familia
      </div>
      <div className="exportable-fields-container" style={{ gap: 20 }}>
        {getFields(typeId).map((e, i) => {
          return (
            <div
              className="data-field"
              key={i}
              onClick={() => {
                if (!toggleGroupedFields) {
                  setSelectedFields([e]);
                  setToggleGroupedFields(false);
                }
              }}
            >
              <RadioButton
                active={
                  !toggleGroupedFields &&
                  selectedFields.find((field) => field === e)
                }
                onClick={() => {}}
              ></RadioButton>
              <span className="label">
                {e === "Genero"
                  ? "Género"
                  : e === "Categoria"
                  ? "Categoría"
                  : e}
              </span>
            </div>
          );
        })}
        {(typeId === 4 || typeId === 6) && (
          <div className="data-field" style={{ marginLeft: 50 }}>
            <CheckBox
              tabIndex={55}
              active={toggleGroupedFields}
              onClick={() => {
                setToggleGroupedFields((prev) => !prev);
              }}
            ></CheckBox>
            <span className="label">Agrupar 1º</span>
            <DropdownFilter
              size={2}
              disabled={!toggleGroupedFields}
              optionList={[
                {
                  id: "Genero",
                  text: "GÉNERO",
                  active: groupedPair.first === "Genero",
                },
                {
                  id: "Forma",
                  text: "FORMA",
                  active: groupedPair.first === "Forma",
                },
                {
                  id: "Material",
                  text: "MATERIAL",
                  active: groupedPair.first === "Material",
                },
              ]}
              op={groupedPair.first}
              selectedOptions={[]}
              onChange={(e) => {
                setGroupedPair((prev) => {
                  let newSecond = prev.second;

                  if (prev.second === e.id) {
                    newSecond = options.find((opt) => opt !== e.id) || "";
                  }

                  return {
                    ...prev,
                    first: e.id,
                    second: newSecond,
                  };
                });
              }}
            ></DropdownFilter>
            <span className="label">Agrupar 2º</span>
            <DropdownFilter
              size={2}
              disabled={!toggleGroupedFields}
              optionList={[
                {
                  id: "Genero",
                  text: "GÉNERO",
                  active: groupedPair.second === "Genero",
                },
                {
                  id: "Forma",
                  text: "FORMA",
                  active: groupedPair.second === "Forma",
                },
                {
                  id: "Material",
                  text: "MATERIAL",
                  active: groupedPair.second === "Material",
                },
              ].filter((e) => e.id !== groupedPair.first)}
              op={groupedPair.second}
              selectedOptions={[]}
              onChange={(e) => {
                setGroupedPair((prev) => {
                  let newFirst = prev.first;

                  if (prev.first === e.id) {
                    newFirst = options.find((opt) => opt !== e.id) || "";
                  }

                  return {
                    ...prev,
                    first: newFirst,
                    second: e.id,
                  };
                });
              }}
            ></DropdownFilter>
          </div>
        )}
      </div>
    </div>
  );
}
